import AuthLayout from "@/layouts/AuthLayout";
import LoginPage from "@/pages/LoginPage";
import { createBrowserRouter, Navigate } from "react-router-dom";

const routes = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/",
        element: <LoginPage />,
      },
    ],
  },
  /* {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },

      // add more authenticated routes here
    ],
  }, */
  {
    path: "*",
    element: <Navigate to={"/"} replace />,
  },
];

export const router = createBrowserRouter(routes);

export default router;
